module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Mary-Queen-of-Scots.64fa7a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Mary-Queen-of-Scots.jpg
// module id = Juot
// module chunks = 0